import React from 'react';
import styled from 'styled-components';

interface GridProps {
  children: React.ReactNode;
}

const CoveragesGrill: React.FC<GridProps> = ({ children }) => {
  return <GridContainer>{children}</GridContainer>;
};

export default CoveragesGrill;

const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin: 20px auto;

  @media (min-width: 768px) {
    width: 100%;
    margin: 40px auto;
    max-width: 1000px;
    gap: 20px;
  }
  @media (min-width: 1024px) {
    max-width: 1300px;
    gap: 30px;
  }
`;
